<template>
    <div></div>
</template>

<script>
    "use strict";

    export default {
        mounted() {
            this.logOut();
        },
        "methods": {
            logOut() {
                localStorage.removeItem("token");
                localStorage.removeItem("expired");
                localStorage.removeItem("role");
                this.$router.push({ "name": "drivers_login" });
            },
        },
    };
</script>
